
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface StoreStats {
  total_images: number;
  designs_created: number;
  active_products: number;
  monthly_sales: number;
}

export const useStoreStats = (storeId: string) => {
  return useQuery({
    queryKey: ['store-stats', storeId],
    queryFn: async (): Promise<StoreStats> => {
      const { data, error } = await supabase.rpc('get_store_stats', {
        store_id_param: storeId
      });

      if (error) {
        console.error('Error fetching store stats:', error);
        throw error;
      }

      // A função retorna um array com um objeto, pegamos o primeiro
      const stats = data?.[0] || {
        total_images: 0,
        designs_created: 0,
        active_products: 0,
        monthly_sales: 0
      };

      return {
        total_images: Number(stats.total_images) || 0,
        designs_created: Number(stats.designs_created) || 0,
        active_products: Number(stats.active_products) || 0,
        monthly_sales: Number(stats.monthly_sales) || 0
      };
    },
    enabled: !!storeId,
  });
};
